import { IHolidayFormFilter } from "../types";

export const HOLIDAY_FILTER_DEFAULTS: IHolidayFormFilter = {
    year: new Date().getFullYear(), // Current year
    tenants: null,
}
